<template>
  <div id="app">
  <v-app id="inspire">
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="orange"
                dark
                flat
              >
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>
                
              </v-toolbar>
              <v-card-text>
               <v-alert 
               v-if="!ok"
               v-model="alert"
      dense
      outlined
      type="error"
      dismissible
    >
      Erro <strong>email ou senha</strong> invalidos !
    </v-alert>

                <v-form>
                  <v-text-field
                    label="Email"
                    v-model="email"
                    prepend-icon="person"
                    type="email"
                  ></v-text-field>
                  <v-text-field
                    label="Senha"
                    v-model="password"
                    prepend-icon="lock"
                    type="password"
                  ></v-text-field>

                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="login()">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</div>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      password: null,
      email: null,
      ok: null,
      alert: false
    }),
    created () {
      this.sessionVerify();
    },
    methods:{

      async sessionVerify(){
        let token =  await localStorage.getItem('api_token');
        if(token){

          this.getSession(token).then(response => {
            if(response){
              this.$router.replace('/home'); 
            }else{
              this.removeUser();
               return false;
            }
            
          }).catch(e=>{
            // console.log(e);
            return e;
          });

         
        }
        return false;
      },
      async getSession(token){
        let url = 'users/session';
        this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        var error = true;

        try{
          await this.$http.get(url).then(response => response.data).then(user => {
          this.setUser(user);
         // user['api_token'] = token;
          this.$user = user;

          error = false;
        });
        }catch(e){
          return e;
           // console.log(e)
        }

        if(!error){
          return true
        }else{
          return false
        }


      },
      setUser(user){
        localStorage.setItem('user_id', user.id);
        localStorage.setItem('user_name', user.name);
        localStorage.setItem('user_email', user.email);
        localStorage.setItem('user_level', user.level);
        localStorage.setItem('user_created_at', user.created_at);
      },
      removeUser(){
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_name');
        localStorage.removeItem('user_email');
        localStorage.removeItem('user_level');
        localStorage.removeItem('user_created_at');
        localStorage.removeItem('api_token');
      },



      async login(){
        let data = new FormData();
        data.append('password', this.password)
        data.append('email', this.email)
        let url = 'users/auth'

        let options = {
          headers: {
            'content-type': 'multipart/form-data'
          }
        }

        let loginCheck = true;

          loginCheck = await this.$http.post(url, data, options).then(function (response) {  
            if(response.data){
              localStorage.setItem('api_token', response.data['api_token']);              
              return true;
            }else{
              return false;
            }  
          });
          this.ok = loginCheck;
          if(loginCheck){
            this.sessionVerify();
          }else{
            this.alert = true;
          }
      }

    }
  }
</script>